import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const COOKIE_KEY = 'cookie-consent';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem(COOKIE_KEY);
    if (!accepted) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '0px',
        backdropFilter: 'blur(6px)',
        background:
          'linear-gradient(135deg, rgba(255,255,255,0.3), rgba(240,240,240,0.2))',
        boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
        padding: '18px 40px',
        zIndex: 1000,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontFamily: 'sans-serif',
        fontSize: '14px',
        flexWrap: 'wrap',
        gap: '16px',
        width: '100%',
      }}
    >
      <div style={{ flex: 1, minWidth: '200px' }}>
        Šī lapa izmanto sīkdatnes. Turpinot to lietot, Tu piekrīti{' '}
        <Link
          to="/cookie-policy"
          style={{ textDecoration: 'underline', color: '#1890ff' }}
        >
          sīkdatņu izmantošanas noteikumiem
        </Link>
      </div>

      <button
        onClick={handleAccept}
        style={{
          backgroundColor: 'rgba(24, 144, 255, 0.4)',
          color: 'black',
          padding: '10px 16px',
          borderRadius: '24px',
          fontWeight: 500,
          cursor: 'pointer',
          border: 'none',
          whiteSpace: 'nowrap',
          marginTop: 0,
        }}
      >
        Piekrītu
      </button>
    </div>
  );
};

export default CookieBanner;
